import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationChangeForm from './LocationChangeForm';

import {
    fetchVolunteerOpportunities,
    manuallySetUserLocation
} from '../../containers/Volunteer/actions';

import {
    AnimationContainer,
    ContainerAbsolute,
    Body
} from '../../containers/DefaultStyles/AssessmentDetails';

const LocationChangePopup = props => (
    <AnimationContainer>
        <ContainerAbsolute>
            <Body>
                <LocationChangeForm
                    onSubmit={values => {
                        props.manuallySetUserLocation({
                            postalCode: values.postalCode,
                            countryCode: values.countryCode
                        });
                        props.fetchVolunteerOpportunities(
                            values.postalCode,
                            values.countryCode || 'US',
                            props.associatedVolunteerId,
                            props.actionIdentifier,
                            props.onPreloadScreen,
                            true, // popup
                            false // cache only
                        );
                    }}
                    onBack={props.onBack}
                    isPostalCodeSubmitting={props.isPostalCodeSubmitting}
                />
            </Body>
        </ContainerAbsolute>
    </AnimationContainer>
);

LocationChangePopup.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    fetchVolunteerOpportunities: PropTypes.func.isRequired,
    manuallySetUserLocation: PropTypes.func.isRequired,
    isPostalCodeSubmitting: PropTypes.bool,
    onBack: PropTypes.func,
    associatedVolunteerId: PropTypes.number.isRequired,
    onPreloadScreen: PropTypes.bool.isRequired
};

export default connect(
    state => {
        return {
            actionIdentifier: state.widget.activeAction.identifier,
            associatedVolunteerId: state.widget.activeAction.id,
            isPostalCodeSubmitting: state.volunteer.isPostalCodeSubmitting,
            onPreloadScreen: state.volunteer.onPreloadScreen
        };
    },
    {
        fetchVolunteerOpportunities,
        manuallySetUserLocation
    }
)(LocationChangePopup);



// WEBPACK FOOTER //
// ./src/components/Volunteer/LocationChangePopup.jsx